import { Component, OnInit, Injector, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Ticket } from '../../models/RestModels';
import { GetEmpty } from '../../classes/Empties';
import { forkJoin, of } from 'rxjs';

@Component({
	selector: 'app-save-ticket-config',
	templateUrl: './save-ticket-config.component.html',
	styleUrls: ['./save-ticket-config.component.css']
})
export class SaveTicketConfigComponent extends BaseComponent implements OnInit {

	ticket: Ticket = GetEmpty.ticket();

	@ViewChild('resizeCanvas') resizeCanvas!: ElementRef<HTMLCanvasElement>;

	display_options = [
		{ value: 'NEVER', label: 'Nunca' },
		{ value: 'ALWAYS', label: 'Siempre' },
		{ value: 'ONLY_IF_HAS_PRICE', label: 'Solo si tiene precio' },
		{ value: 'ONLY_IF_PRESENT', label: 'Solo si esta presente' }
	];

	name_display_options = [
		{ value: 'TRUNCATED', label: 'Truncado' },
		{ value: 'FULL', label: 'Completo' }
	];

	constructor(public injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.setTitle('Configuracion de Ticket');

		this.is_loading = true;

		this.subs.sink = this.route.paramMap.subscribe(params => {
			const ticketId = params.has('id') ? parseInt(params.get('id') as string) : 0;

			if (ticketId) {
				this.subs.sink = this.rest.ticket.get(ticketId).subscribe(
					(response) => {
						this.is_loading = false;
						this.ticket = response;
					},
					(error) => {
						this.is_loading = false;
						this.showError('Error al cargar la configuracion');
					}
				);
			} else {
				this.is_loading = false;
			}
		});
	}

	/**
	 * Save ticket configuration
	 */
	save() {
		this.is_loading = true;

		if (!this.ticket.name) {
			this.showError('El nombre es requerido');
			this.is_loading = false;
			return;
		}

		const observable = this.ticket.id
			? this.rest.ticket.update(this.ticket)
			: this.rest.ticket.create(this.ticket);

		this.subs.sink = observable.subscribe(
			(response) => {
				this.is_loading = false;
				this.ticket = response;
				// Refresh the cached ticket so printing uses the updated values
				this.rest.refreshCurrentTicket();
				this.showSuccess('Configuracion guardada correctamente');
			},
			(error) => {
				this.is_loading = false;
				this.showError('Error al guardar: ' + error?.message);
			}
		);
	}

	onImageSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (!input.files || input.files.length === 0) return;

		const file = input.files[0];
		const reader = new FileReader();

		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				const canvas = this.resizeCanvas.nativeElement;
				const ctx = canvas.getContext('2d');
				if (!ctx) return;

				let targetWidth = this.ticket.image_width || 128;
				targetWidth = Math.ceil(targetWidth / 8) * 8;
				const scale = targetWidth / img.width;
				let targetHeight = Math.round(img.height * scale);

				targetHeight = Math.ceil(targetHeight / 8) * 8;

				canvas.width = targetWidth;
				canvas.height = targetHeight;

				ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

				const imageData = ctx.getImageData(0, 0, targetWidth, targetHeight);
				const data = imageData.data;
				for (let i = 0; i < data.length; i += 4) {
					const gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
					data[i] = gray;
					data[i + 1] = gray;
					data[i + 2] = gray;
				}
				ctx.putImageData(imageData, 0, 0);

				const base64 = canvas.toDataURL('image/png');
				const imageTag = `<Image width="${targetWidth}" height="${targetHeight}">${base64}</Image>`;
				const originalHeader = this.ticket.header || '';
				this.ticket.header = imageTag + '\n' + originalHeader;

				this.showSuccess('Imagen agregada al encabezado');
			};
			img.src = e.target?.result as string;
		};

		reader.readAsDataURL(file);
		input.value = '';
	}
}
